/*
 * Description: Display Warning Web Component
 * Purpose: Displays a warning message using Bootstrap alert styling
 * Author: Nuvemx
 * Created: 2025
 *
 * Features:
 * - Bootstrap alert-warning styling with Boxicons icon
 * - Optional title attribute
 * - Slot-based content
 *
 * Usage:
 * <display-warning title="Warning:">This action cannot be undone.</display-warning>
 * <display-warning>Critical notice without title.</display-warning>
 *
 * Attributes:
 * - title: String - Optional bold heading text
 *
 */

import './display_warning.css';

class display_warning extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) return;

        const title = this.getAttribute('title');
        const content = document.createElement('div');
        content.className = 'warning-content';
        while (this.firstChild) {
            content.appendChild(this.firstChild);
        }

        this.innerHTML = `
            <div class="alert warning-alert d-flex" role="alert">
                <i class="bx bx-error warning-icon fs-5"></i>
                <div class="warning-body">
                    ${title ? '<div class="warning-title"><strong></strong></div>' : ''}
                    <div class="warning-content"></div>
                </div>
            </div>`;

        if (title) {
            this.querySelector('.warning-title strong').textContent = title;
        }
        this.querySelector('.warning-content').appendChild(content);

        this.dataset.rendered = "true";
    }
}

export { display_warning };
